import { Button } from '@/components/ui/button';
import { ArrowRight, FileText } from '@phosphor-icons/react';

const HERO_BG_STYLE = {
  background:
    "linear-gradient(135deg, rgba(10, 22, 40, 0.96) 0%, rgba(15, 23, 42, 0.88) 55%, rgba(13, 148, 136, 0.32) 100%), url('https://images.pexels.com/photos/1181406/pexels-photo-1181406.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1280')",
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};

const scrollTo = (id) => () => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

const HeroSection = ({ onStart }) => (
  <section
    id="top"
    className="relative py-24 lg:py-32 overflow-hidden"
    style={HERO_BG_STYLE}
    data-testid="hero-section"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="max-w-3xl">
        <div
          data-testid="hero-tagline"
          className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-bold text-teal-300 mb-6 px-3 py-1 border border-teal-400/30 rounded-full bg-teal-400/5"
        >
          Workflow Stability & AI Readiness Diagnostic
        </div>
        <h1
          data-testid="hero-title"
          className="text-4xl sm:text-5xl lg:text-6xl tracking-tight font-black text-white mb-6 leading-[1.08]"
        >
          Fix Workflow Problems Before Investing in Automation and AI.
        </h1>
        <p className="text-lg sm:text-xl text-slate-300 leading-relaxed mb-8 max-w-2xl">
          Many automation and AI initiatives fail because the underlying workflows are not
          yet stable, standardised, or governed. AWSAI helps organisations diagnose workflow
          readiness, identify operational risks, and prioritise improvement before investing
          further in digital tools, automation, or AI.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            data-testid="hero-start-assessment"
            onClick={onStart}
            size="lg"
            className="bg-white text-slate-900 hover:bg-slate-100 hover:-translate-y-0.5 transition-all shadow-lg font-semibold"
          >
            Start Free Assessment
            <ArrowRight size={20} weight="bold" className="ml-2" />
          </Button>
          <Button
            data-testid="hero-request-report"
            onClick={scrollTo('pricing')}
            size="lg"
            variant="outline"
            className="border-2 border-white text-white hover:bg-white/10"
          >
            <FileText size={20} weight="bold" className="mr-2" />
            Request Professional Report
          </Button>
        </div>
        <div className="mt-10 flex flex-wrap gap-x-8 gap-y-2 text-xs text-slate-400 uppercase tracking-[0.18em] font-medium">
          <span>For SMEs &middot; Universities &middot; Government Agencies</span>
          <span>Healthcare &middot; Professional Services &middot; NGOs</span>
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
